export default __webpack_public_path__ + "static/media/event-3.b59ca72e.JPG";